import { render } from "./SProduktField.vue?vue&type=template&id=2533fb0a"
import script from "./SProduktField.vue?vue&type=script&lang=js"
export * from "./SProduktField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__